import React from 'react'

//import './standard-modal.scss'
import GenericModal from '../generic-modal/generic-modal'
import Button from '../../atoms/button/button'

const Wrapper = ({ noLayoutModal, children  })=>(noLayoutModal? <div> {children} </div>: <GenericModal> {children}</GenericModal>)
    
const StandardModal = ({ title, subtitle, description, button_title, click, clickButton, noButton, noClose, noLayoutModal }) => {
    return (
        <Wrapper noLayoutModal={noLayoutModal}>
            <div className="f-modal-info">
                <div className="f-main-title-container">
                    <label className="f-main-title">
                        {title}
                    </label>
                </div>

                {subtitle !== '' && 
                    <div className="f-sub-title-container-generic">
                        <label className="f-sub-title">
                            {subtitle}
                        </label>
                    </div>
                }

                {description !== '' && <div className="f-description-container">
                    <label className="f-description">
                        {description}
                    </label>
                </div>}
                <br />
                <br />
                {!noButton && <div className="f-button-action-container" onClick={clickButton ? clickButton : click}>
                    <Button
                        className='primary-pink short'
                        title={button_title}
                    />
                </div>}
            </div>
            {!noClose && <span
                className="icon2-close f-close-icon"
                onClick={click}
            />}
        </Wrapper>
    )
}

export default StandardModal
